import * as Yup from 'yup'

export const SiteKeyItemsValidationSchema = Yup.object().shape({
  EntityType: Yup.string().required('This field is required'),
  EntityId: Yup.string().required('This field is required'),
  UserId: Yup.string().required('This field is required'),
  WalletType: Yup.string().required('This field is required'),
  Mode: Yup.string().required('This field is required'),
  Hosts: Yup.array().min(1),
  CORSURLs: Yup.array().min(1)
})
